import React from 'react';
import ConfirmationDialog from 'components/Utils/ConfirmationDialog';
import DefaultButton from 'components/Utils/NewDefaultButton';

// Shown when archiving a task that isn't done yet, so it doesn't land in the
// archive still looking pending. onArchive receives whether to mark it completed.
const ArchiveTaskDialog = ({ open, loading, onArchive, onCancel }) => (
  <ConfirmationDialog
    open={open}
    title="Archive Task"
    message="This task isn't completed. Do you want to mark it as completed before archiving?"
    confirmLabel="Mark Completed"
    onConfirm={() => onArchive(true)}
    onCancel={onCancel}
    cancelClassName="white"
    loadingState={loading}
    additionalButton={
      <DefaultButton
        name="Leave Incomplete"
        className="white"
        onClick={() => onArchive(false)}
        disabled={loading}
        style={{ width: '150px', marginRight: '20px' }}
      />
    }
  />
);

export default ArchiveTaskDialog;
